import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

Button.propTypes = {
  type: PropTypes.oneOf(['circle', 'regular']),
  style: PropTypes.oneOf([
    'success',
    'error',
    'primary',
    'accent',
    'secondary',
    'warning',
    'multi-colored',
  ]),
  size: PropTypes.oneOf(['small', 'regular', 'large']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  mode: PropTypes.oneOf(['button', 'link', 'navLink']),
  href: PropTypes.string,
  children: PropTypes.node,
  shadowEffects: PropTypes.bool,
  tooltipText: PropTypes.any,
  disabled: PropTypes.bool,
  analyticsTrackingName: PropTypes.string,
};
export default function Button({
  type = 'regular',
  style = 'secondary',
  size = 'regular',
  mode,
  onClick,
  href,
  className,
  children,
  shadowEffects = true,
  tooltipText,
  disabled = false,
  analyticsTrackingName,
}) {
  const buttonClassNameItems = ['btn'];

  if (size !== 'regular')
    if (size === 'small') buttonClassNameItems.push('btn-sm');
    else buttonClassNameItems.push('btn-lg');

  if (shadowEffects) buttonClassNameItems.push('shadow-sm', 'hover:shadow-md');

  if (type !== 'regular') buttonClassNameItems.push('btn-circle');

  const buttonClassName = buttonClassNameItems.join(' ');

  if (mode === 'button') {
    if (!onClick) throw new Error('Mode is button but is missing onClick prop');

    let buttonBlock = analyticsTrackingName ? (
      <button
        data-track={analyticsTrackingName}
        disabled={disabled}
        className={`${buttonClassName} btn-${style} shadow-sm hover:shadow-md ${className}`}
        onClick={onClick}
      >
        <div className="z-10 flex justify-around items-center">{children}</div>
      </button>
    ) : (
      <button
        disabled={disabled}
        className={`${buttonClassName} btn-${style} shadow-sm hover:shadow-md ${className}`}
        onClick={onClick}
      >
        <div className="z-10 flex justify-around items-center">{children}</div>
      </button>
    );

    if (tooltipText)
      return (
        <div className="tooltip" data-tip={tooltipText}>
          {buttonBlock}
        </div>
      );

    return buttonBlock;
  } else if (mode === 'navLink') {
    if (!href) throw new Error('Mode is navLink but is missing href prop');

    let navLinkBlock = analyticsTrackingName ? (
      <NavLink
        data-track={analyticsTrackingName}
        unstable_viewTransition
        unselectable={disabled ? 'on' : 'off'}
        className={`${buttonClassName} btn-${style} shadow-sm hover:shadow-md ${className}`}
        to={href}
      >
        <div className="z-10 flex justify-around items-center">{children}</div>
      </NavLink>
    ) : (
      <NavLink
        unstable_viewTransition
        unselectable={disabled ? 'on' : 'off'}
        className={`${buttonClassName} btn-${style} shadow-sm hover:shadow-md ${className}`}
        to={href}
      >
        <div className="z-10 flex justify-around items-center">{children}</div>
      </NavLink>
    );

    if (tooltipText)
      return (
        <div className="tooltip" data-tip={tooltipText}>
          {navLinkBlock}
        </div>
      );

    return navLinkBlock;
  }

  if (!href) throw new Error('Mode is link but is missing href prop');

  let aBlock = analyticsTrackingName ? (
    <a
      data-track={analyticsTrackingName}
      aria-disabled={disabled}
      className={`${buttonClassName} btn-${style} shadow-sm hover:shadow-md ${className}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="z-10 flex justify-around items-center">{children}</div>
    </a>
  ) : (
    <a
      aria-disabled={disabled}
      className={`${buttonClassName} btn-${style} shadow-sm hover:shadow-md ${className}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="z-10 flex justify-around items-center">{children}</div>
    </a>
  );

  if (tooltipText)
    return (
      <div className="tooltip" data-tip={tooltipText}>
        {aBlock}
      </div>
    );

  return aBlock;
}
